
import Component, { ComponentMethods } from "../module/component/component"

import elemIcon from './elem-icon.vue'

class AboutPage extends ComponentMethods implements ComponentEntity {

    props = {
        
    }

    components = {
        elemIcon
    }

    watch = {
        
    }

    methods = {
        
    }
}

export default Component.build(new AboutPage)
